import React from "react";
import { Link } from "react-router-dom";

const courses = [
    {
      slug: "android",
      tag: "MODULE_01",
      badge: "CORE",
      title: "Android Repair",
      desc: "Complete teardown, hardware diagnostics, and software flashing across Samsung, Xiaomi, Oppo, Vivo.",
      img: "/images/course1.png",
      to: "/courses/android",
    },
    {
      slug: "iphone",
      tag: "MODULE_02",
      badge: "ELITE",
      title: "iPhone Repair",
      desc: "Face ID, battery programming, tristar IC and precision repair on iPhone 11 through 15 series.",
      img: "/images/course2.png",
      to: "/courses/iphone",
    },
    {
      slug: "chip",
      tag: "MODULE_03",
      badge: "ADVANCED",
      title: "Chip Level Repair",
      desc: "Trace circuits, diagnose shorts, and master DC power supplies, oscilloscopes and thermal cameras.",
      img: "/images/course3.png",
      to: "/courses/chip-level",
    },
    {
      slug: "reballing",
      tag: "MODULE_04",
      badge: "SPECIALIST",
      title: "Reballing Course",
      desc: "BGA reballing for CPU, eMMC, UFS. Stencils, low-temp solder balls and precision reflow.",
      img: "/images/course4.png",
      to: "/courses/reballing",
    },
    {
      slug: "micro",
      tag: "MODULE_05",
      badge: "PRO",
      title: "Micro-Soldering",
      desc: "Sub-millimeter jumper wire techniques, IC leg repair and board-level rework at 40× magnification.",
      img: "/images/course1.png",
      to: "/courses/chip-level",
    },
    {
      slug: "online",
      tag: "MODULE_06",
      badge: "REMOTE",
      title: "Online Classes",
      desc: "Live remote training with recorded playback, WhatsApp mentor group and doorstep toolkit delivery.",
      img: "/images/course1.png",
      to: "/courses/online",
    },
  ];

function CoursesSection() {
  return (
    <section className="courses-section scroll-reveal">
      <div className="courses-container scroll-reveal">
        <div className="courses-header scroll-reveal">
          <div>
            <div className="courses-subtitle scroll-reveal">Programs</div>

            <h2 className="courses-title scroll-reveal">
              Six specialized training tracks.
            </h2>
          </div>

          <Link to="/courses" className="view-all scroll-reveal">
            View all courses →
          </Link>
        </div>

        <div className="courses-grid scroll-reveal">
          {courses.map((c, index) => (
            <Link
              key={c.slug}
              to={c.to}
              className="course-card scroll-reveal"
              data-reveal-delay={(index % 6) + 1}
            >
              <div className="course-top">
                <span className="course-tag">{c.tag}</span>

                <span className="course-badge">
                  {c.badge}
                </span>
              </div>

              <h3 className="course-title">
                {c.title}
              </h3>

              <p className="course-desc">
                {c.desc}
              </p>

              <img
                src={c.img}
                alt={c.title}
                className="course-image"
              />

              <span className="course-link">
                View Curriculum →
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CoursesSection;